import { render, staticRenderFns } from "./ShowroomBreadcrumbs.vue?vue&type=template&id=477272e9&scoped=true&"
import script from "./ShowroomBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ShowroomBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ShowroomBreadcrumbs.vue?vue&type=style&index=0&id=477272e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477272e9",
  null
  
)

export default component.exports